var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstFloor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 676.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1280 324.992 689.91 665.709 0 267.309 417.572 26.203 780.675 235.882 953.172 136.281 1280 324.992",
    fill: "#b5b1ae"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 267.309 0 277.792 689.91 676.193 689.91 665.709 0 267.309",
    fill: "#eff7df"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1280 335.476 1280 324.992 689.91 665.709 689.91 676.193 1280 335.476",
    fill: "#9d718a"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor_Inner"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "326.778 131.045 717.145 356.442 553.736 451.077 163.407 225.398 326.778 131.045",
    fill: "#4a2a3f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "753.458 576.599 1189.216 324.992 989.494 209.728 762.537 340.694 853.324 393.135 644.519 513.697 753.458 576.599",
    fill: "#4a2a3f"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ground_Floor"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "971.347 209.678 971.347 136.292 1180.138 256.848 1180.138 330.234 971.347 209.678",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1053.042 256.848 1053.042 183.463 989.494 220.156 989.494 293.541 1053.042 256.848",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1098.403 283.066 1098.403 209.681 1034.855 246.374 1034.855 319.759 1098.403 283.066",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "798.84 319.745 798.859 246.348 980.416 141.529 980.416 214.914 798.84 319.745",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.291 230.639 335.857 125.932 335.857 52.546 154.291 156.999 154.291 220.156 154.291 230.639",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.291 146.77 326.87 47.229 335.948 52.471 163.369 152.012 154.291 146.77",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "971.347 136.292 1180.138 256.848 1189.236 251.596 980.416 131.045 971.347 136.292",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "898.711 377.41 889.633 372.168 971.337 324.992 980.416 330.234 898.711 377.41",
    fill: "none",
    stroke: "red",
    strokeMiterlimit: 10,
    strokeWidth: 0.346
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "789.771 314.497 798.84 319.745 798.859 246.348 789.762 241.117 789.771 314.497",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "762.537 340.717 753.458 335.476 726.224 351.201 735.302 356.443 762.537 340.717",
    fill: "none",
    stroke: "red",
    strokeMiterlimit: 10,
    strokeWidth: 0.346
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "753.459 262.09 762.537 267.332 735.302 283.058 726.223 277.815 753.459 262.09",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.344 225.397 453.875 193.947 444.796 199.188 499.266 230.639 508.344 225.397",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "789.762 241.117 798.859 246.348 989.505 136.292 980.416 131.045 789.762 241.117",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.466 309.267 290.465 235.881 145.213 152.012 145.213 225.397 290.466 309.267",
    fill: "none",
    stroke: "#f93728",
    strokeMiterlimit: 10,
    strokeWidth: 0.346
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.7 52.418 326.778 47.176 526.501 162.496 517.422 167.738 317.7 52.418",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.778 57.769 326.778 131.045 517.422 241.123 517.422 167.738 326.778 57.769",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.857 262.09 517.422 157.254 526.501 162.496 344.935 267.332 335.857 262.09",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.935 340.717 526.501 235.859 526.501 162.474 344.935 267.332 344.935 340.717",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.405 288.299 390.327 293.541 390.327 366.926 399.405 361.685 399.405 288.299",
    fill: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.327 366.926 390.326 356.359 335.857 324.992 335.857 335.476 390.327 366.926",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "543.965 177.853 521.962 165.095 526.501 162.474 548.504 175.232 543.965 177.853",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "543.965 251.238 521.962 238.48 521.962 165.095 543.965 177.853 543.965 251.238",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "543.964 251.229 543.964 177.854 548.503 175.232 548.503 248.608 543.964 251.229",
    fill: "#a3673e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "772.298 256.496 794.301 243.739 789.762 241.117 767.759 253.876 772.298 256.496",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "772.298 329.882 794.301 317.124 794.301 243.739 772.299 256.497 772.298 329.882",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "772.299 329.873 772.299 256.497 767.76 253.876 767.76 327.251 772.299 329.873",
    fill: "#a3673e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "899.404 235.535 921.407 222.777 916.868 220.156 894.865 232.914 899.404 235.535",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "899.404 308.92 921.407 296.162 921.407 222.777 899.404 235.535 899.404 308.92",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "899.405 308.911 899.405 235.536 894.865 232.914 894.865 306.289 899.405 308.911",
    fill: "#a3673e"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "544.657 183.452 544.657 256.837 717.145 356.442 717.145 283.057 544.657 183.452",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "544.657 382.652 726.223 277.815 735.302 283.058 553.736 387.893 544.657 382.652",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "553.736 461.279 553.736 387.893 762.537 267.332 762.537 340.717 553.736 461.279",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "726.224 288.299 544.657 183.452 553.736 178.21 735.302 283.058 726.224 288.299",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "807.928 293.541 698.989 356.443 708.067 361.684 817.007 298.773 807.928 293.541",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "898.702 241.117 898.702 304.025 853.319 330.234 844.241 335.475 844.241 272.574 898.702 241.117",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "807.913 304.025 807.913 377.401 844.242 398.377 844.241 324.992 807.913 304.025",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "708.067 361.684 708.067 435.07 698.989 429.828 698.989 356.443 708.067 361.684",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "807.913 377.401 708.067 435.07 708.067 361.684 807.913 304.025 807.913 377.401",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "681.525 371.822 703.528 359.064 698.989 356.443 676.986 369.201 681.525 371.822",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "681.525 445.207 703.528 432.449 703.528 359.064 681.525 371.822 681.525 445.207",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "681.525 445.198 681.525 371.823 676.986 369.201 676.986 442.577 681.525 445.198",
    fill: "#a3673e"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "898.711 304.025 835.163 267.332 835.163 340.717 898.711 377.41 898.711 304.025",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671.754 372.173 626.362 398.377 635.441 403.619 680.832 377.405 671.754 372.173",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "862.398 324.992 807.928 293.541 798.84 298.777 853.319 330.234 862.398 324.992",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "844.242 262.09 907.789 298.783 898.711 304.025 835.163 267.332 844.242 262.09",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.369 214.914 163.369 152.012 154.291 156.999 154.291 220.156 163.369 214.914",
    fill: "none",
    stroke: "#909296",
    strokeMiterlimit: 10,
    strokeWidth: 0.346
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "889.633 235.881 898.702 241.117 844.241 272.574 835.163 267.332 889.633 235.881",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "680.832 377.405 680.832 450.795 644.519 471.762 635.44 477.004 635.441 403.619 680.832 377.405",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.362 471.763 626.362 398.377 671.754 424.586 671.754 497.971 626.362 471.763",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.074 272.574 254.152 267.332 163.369 214.914 154.291 220.156 245.074 272.574",
    fill: "#aaabad"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "653.597 518.939 653.597 445.553 862.398 324.992 862.398 398.377 653.597 518.939",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.326 356.359 399.405 351.117 363.092 330.234 354.014 335.476 390.326 356.359",
    fill: "#aaabad"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.092 330.234 354.014 335.476 354.014 283.058 363.092 277.816 363.092 330.234",
    fill: "#909296"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.895 382.652 444.816 387.894 444.816 335.476 453.894 330.234 453.895 382.652",
    fill: "#909296"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.23 272.574 254.152 277.816 254.152 225.398 263.23 220.156 263.23 272.574",
    fill: "#909296"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.152 277.816 290.465 298.783 299.544 293.541 263.23 272.574 254.152 277.816",
    fill: "#aaabad"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.544 304.025 299.543 230.639 290.465 235.881 290.466 309.267 299.544 304.025",
    fill: "#909296"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "254.153 225.482 258.692 222.86 295.004 243.743 295.004 296.162 290.465 298.783 254.153 277.9 254.153 225.482",
    fill: "#00bdff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.439 298.771 254.152 277.9 258.691 275.279 294.979 296.15 290.439 298.771",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.439 246.364 254.152 225.493 258.691 222.872 294.979 243.743 290.439 246.364",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.153 277.9 254.153 225.482 258.692 222.86 258.692 275.279 254.153 277.9",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.465 298.783 290.465 246.365 295.004 243.743 295.004 296.162 290.465 298.783",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "344.936 277.858 349.475 275.236 394.866 301.319 394.866 353.738 390.326 356.359 344.936 330.276 344.936 277.858",
    fill: "#00bdff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.301 356.347 344.935 330.276 349.474 327.655 394.84 353.726 390.301 356.347",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.301 303.94 344.935 277.869 349.474 275.248 394.84 301.319 390.301 303.94",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.936 330.276 344.936 277.858 349.475 275.236 349.475 327.655 344.936 330.276",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.326 356.359 390.326 303.941 394.866 301.319 394.866 353.738 390.326 356.359",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "154.291 167.738 158.831 165.116 249.613 217.523 249.613 269.941 245.074 272.563 154.291 220.156 154.291 167.738",
    fill: "#00bdff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.048 272.551 154.291 220.156 158.83 217.535 249.588 269.93 245.048 272.551",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.048 220.144 154.291 167.749 158.83 165.128 249.588 217.523 245.048 220.144",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.291 220.156 154.291 167.738 158.831 165.116 158.83 217.535 154.291 220.156",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.074 272.563 245.074 220.145 249.613 217.523 249.613 269.941 245.074 272.563",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "145.212 214.914 290.465 298.783 290.465 309.267 145.213 225.397 145.212 214.914",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.213 152.012 154.291 156.999 154.291 230.639 145.213 225.397 145.213 152.012",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.213 152.012 154.291 146.77 299.543 230.639 290.465 235.881 145.213 152.012",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.466 246.365 290.465 235.881 145.213 152.012 145.213 162.496 290.466 246.365",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.074 272.574 245.074 209.672 254.152 214.914 254.152 277.816 245.074 272.574",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "708.067 466.521 708.067 539.906 698.784 545.138 698.784 471.762 708.067 466.521",
    fill: "#909296"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "708.051 529.413 698.784 534.546 744.38 560.873 753.356 555.572 708.051 529.413",
    fill: "#aaabad"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "553.736 461.279 553.736 387.893 435.718 319.75 435.718 393.135 553.736 461.279",
    fill: "none",
    stroke: "#c6c9cc",
    strokeMiterlimit: 10,
    strokeWidth: 0.346
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "544.658 445.553 553.736 440.312 453.875 382.694 444.797 387.936 544.658 445.553",
    fill: "#aaabad"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "444.797 335.476 449.336 332.854 549.197 390.514 549.197 442.932 544.658 445.553 444.797 387.894 444.797 335.476",
    fill: "#00bdff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "544.632 445.541 444.796 387.894 449.335 385.273 549.171 442.921 544.632 445.541",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "544.632 393.135 444.796 335.487 449.335 332.866 549.171 390.514 544.632 393.135",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.797 387.894 444.797 335.476 449.336 332.854 449.336 385.273 444.797 387.894",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "544.658 445.553 544.658 393.135 549.197 390.514 549.197 442.932 544.658 445.553",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "544.658 455.955 544.658 393.053 553.736 398.295 553.736 461.197 544.658 455.955",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.149,551.41c.668,0,.67-1.039,0-1.039s-.67,1.039,0,1.039h0Z",
    fill: "#c6c9cc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "312.468 248.639 290.465 235.881 295.004 233.26 317.007 246.018 312.468 248.639",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.468 322.025 290.465 309.267 290.465 235.881 312.468 248.639 312.468 322.025",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.467 322.015 312.467 248.64 317.007 246.019 317.007 319.394 312.467 322.015",
    fill: "#a3673e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "335.857 262.09 313.854 249.332 318.393 246.711 340.396 259.469 335.857 262.09",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.857 335.476 313.854 322.717 313.854 249.332 335.857 262.09 335.857 335.476",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.856 335.466 335.856 262.091 340.396 259.469 340.396 332.845 335.856 335.466",
    fill: "#a3673e"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "390.301 303.94 390.3 293.456 335.857 262.09 335.857 272.574 390.301 303.94",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.935 267.155 344.935 340.675 335.857 335.476 335.857 262.09 344.935 267.155",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.327 293.541 399.405 288.299 344.935 256.849 335.857 262.09 390.327 293.541",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "412.33 306.299 390.327 293.541 394.866 290.92 416.869 303.678 412.33 306.299",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.33 379.685 390.327 366.926 390.327 293.541 412.33 306.299 412.33 379.685",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.329 379.675 412.329 306.3 416.868 303.678 416.868 377.054 412.329 379.675",
    fill: "#a3673e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "435.719 319.75 413.716 306.992 418.255 304.371 440.258 317.129 435.719 319.75",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.719 393.135 413.716 380.377 413.716 306.992 435.719 319.75 435.719 393.135",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.718 393.126 435.718 319.751 440.257 317.129 440.257 390.505 435.718 393.126",
    fill: "#a3673e"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "553.736 461.197 553.736 450.713 435.731 382.734 435.731 393.218 553.736 461.197",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.718 393.135 435.718 330.234 444.796 335.476 444.796 398.377 435.718 393.135",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "553.736 398.255 553.736 387.771 435.731 319.792 435.731 330.276 553.736 398.255",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.718 319.75 553.736 387.893 562.814 382.652 444.796 314.508 435.718 319.75",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "675.395 458.312 653.392 445.554 657.931 442.933 679.934 455.691 675.395 458.312",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "675.395 531.697 653.392 518.939 653.392 445.554 675.395 458.312 675.395 531.697",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "675.394 531.688 675.394 458.312 679.934 455.691 679.933 529.066 675.394 531.688",
    fill: "#a3673e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "698.784 471.762 676.781 459.004 681.32 456.383 703.323 469.142 698.784 471.762",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "698.784 545.148 676.781 532.39 676.781 459.004 698.784 471.762 698.784 545.148",
    fill: "#864a1f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "698.783 545.138 698.783 471.763 703.323 469.142 703.322 542.517 698.783 545.138",
    fill: "#a3673e"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "753.458 576.599 698.784 545.138 698.784 534.546 753.459 566.115 753.458 576.599",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "698.784 482.271 703.324 479.65 748.919 505.833 748.919 558.252 744.38 560.873 698.784 534.69 698.784 482.271",
    fill: "#00bdff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "744.354 560.861 698.784 534.69 703.323 532.069 748.893 558.24 744.354 560.861",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "744.354 508.454 698.784 482.283 703.323 479.662 748.893 505.834 744.354 508.454",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "698.784 534.69 698.784 482.271 703.324 479.65 703.324 532.068 698.784 534.69",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "744.38 560.873 744.38 508.455 748.919 505.833 748.919 558.252 744.38 560.873",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "753.458 576.599 744.38 571.357 744.38 497.971 753.459 503.213 753.458 576.599",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "916.868 293.541 1080.277 387.893 1080.291 314.516 916.868 220.156 916.868 293.541",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1066.621 311.908 1066.621 318.856 1066.621 323.439 1071.647 320.338 1071.647 314.81 1066.621 311.908",
    fill: "#9d718a"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "698.784 482.271 698.784 471.762 744.38 497.971 744.354 508.454 698.784 482.271",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "708.067 466.521 698.784 471.762 753.459 503.213 762.537 497.972 708.067 466.521",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1025.838 241.149 1025.838 314.526 1034.855 319.759 1034.916 246.391 1025.838 241.149",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "980.477 214.931 989.494 220.156 989.494 293.541 980.411 288.296 980.477 214.931",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "853.32 319.75 862.398 324.992 653.597 445.553 644.519 440.312 853.32 319.75",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.44 393.135 689.91 424.586 680.832 429.828 626.362 398.377 635.44 393.135",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.519 513.697 653.597 518.939 653.597 445.553 644.519 440.312 644.519 513.697",
    fill: "#fcb76c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "980.416 330.234 980.416 256.848 898.711 304.025 898.711 377.41 980.416 330.234",
    fill: "#513a4c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "898.711 304.025 889.633 298.783 980.416 246.364 989.494 251.607 898.711 304.025",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "989.555 220.173 980.477 214.931 1053.042 172.962 1062.121 178.204 989.555 220.173",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1075.702 317.08 1075.702 390.463 1071.162 393.085 980.387 445.5 980.387 372.113 1071.162 319.701 1075.702 317.08",
    fill: "#00bdff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1075.702 379.995 1075.702 385.227 1071.162 387.849 980.387 440.264 975.858 437.653 1071.162 382.616 1075.702 379.995",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "984.934 369.509 984.934 442.875 980.394 445.497 980.394 372.13 984.934 369.509",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1025.797 345.924 1025.797 414.025 1021.257 411.372 1021.257 343.303 1025.797 345.924",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1030.342 343.316 1030.342 416.682 1025.802 419.303 1025.802 345.937 1030.342 343.316",
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1071.159 319.716 1071.159 387.817 1066.619 385.164 1066.619 317.094 1071.159 319.716",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1075.703 317.107 1075.703 390.473 1071.163 393.095 1071.163 319.728 1075.703 317.107",
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "980.388 372.114 980.388 445.51 975.848 442.881 975.848 369.493 980.388 372.114",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1075.702 385.22 1075.702 390.463 1071.162 393.085 980.387 445.497 980.387 440.254 1071.162 387.842 1075.702 385.22",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1075.702 317.1 1075.702 322.343 1071.162 324.965 984.934 374.752 980.394 377.373 980.387 377.377 980.387 372.134 980.394 372.13 984.934 369.509 1071.162 319.722 1075.702 317.1",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1075.685 317.087 980.387 372.113 975.858 369.502 1071.165 314.462 1075.685 317.087",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1034.916 246.391 1025.838 241.149 1098.403 199.18 1107.481 204.422 1034.916 246.391",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "950.911 378.712 896.432 347.27 898.702 345.959 953.181 377.402 950.911 378.712",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "953.176 450.785 953.181 377.402 950.911 378.712 950.906 452.096 953.176 450.785",
    fill: "#a3673e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "950.916 452.095 896.432 420.655 896.432 347.27 950.915 378.71 950.916 452.095",
    fill: "#864a1f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "925.812 368.127 871.333 336.684 873.602 335.373 928.081 366.816 925.812 368.127",
    fill: "#8c5732"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "928.076 440.2 928.081 366.817 925.812 368.127 925.807 441.51 928.076 440.2",
    fill: "#a3673e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "925.816 441.509 871.333 410.069 871.333 336.684 925.816 368.124 925.816 441.509",
    fill: "#864a1f"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "925.946 214.914 916.868 220.156 1080.291 314.516 1089.356 309.267 925.946 214.914",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1189.234 251.594 1189.217 324.991 1075.663 390.556 1075.663 386.982 1075.666 317.169 1189.234 251.594",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "916.867 408.861 916.867 471.763 907.789 466.521 907.789 403.619 916.867 408.861",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "817.058 539.876 925.936 476.999 925.946 466.521 817.058 529.452 817.058 539.876",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1189.234 251.594 1075.701 317.148 1066.621 311.908 1180.137 246.365 1189.234 251.594",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "916.867 471.763 907.789 466.521 807.928 524.181 817.058 529.452 916.867 471.763",
    fill: "#694960"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "916.867 419.315 912.328 416.693 812.467 474.352 812.467 526.771 817.006 529.392 916.867 471.733 916.867 419.315",
    fill: "#00bdff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "817.032 529.38 916.868 471.733 912.329 469.112 812.493 526.759 817.032 529.38",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "817.032 476.973 916.868 419.326 912.329 416.705 812.493 474.352 817.032 476.973",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "916.867 471.733 916.867 419.315 912.328 416.693 912.328 469.111 916.867 471.733",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "817.006 529.392 817.006 476.974 812.467 474.352 812.467 526.771 817.006 529.392",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "817.058 476.974 925.936 414.097 925.946 403.619 817.058 466.551 817.058 476.974",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "753.459 503.213 817.058 466.551 817.058 539.876 753.458 576.599 753.459 503.213",
    fill: "#9d718a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "980.414 372.167 753.458 503.213 744.382 497.97 971.337 366.925 980.414 372.167",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "980.313 372.226 980.31 445.614 916.868 482.245 916.868 408.861 980.313 372.226",
    fill: "#9d718a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstFloor);
export default __webpack_public_path__ + "static/media/first-floor.37980fb5fd5eaa8e0285e87c9b09acae.svg";
export { ForwardRef as ReactComponent };